// src/store/thunks/resourceThunk.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { generateConfig } from "../../utils/api";
import { handleApiError } from "../../utils/apiErrorHandler";

export const fetchClinicResources = createAsyncThunk(
  "resources/fetchClinicResources",
  async (clinicId, { rejectWithValue, getState, dispatch }) => {
    const state = getState();
    const token = state.auth.token;
    const { baseURL, config } = generateConfig({ token });

    try {
      const response = await axios.get(
        `${baseURL}/api/clinics/${clinicId}/resources`,
        config
      );
      return response.data;
    } catch (error) {
      return handleApiError(error, rejectWithValue, dispatch);
    }
  }
);

export const createResource = createAsyncThunk(
  "resources/createResource",
  async (
    { clinicId, resourceData },
    { rejectWithValue, getState, dispatch }
  ) => {
    const state = getState();
    const token = state.auth.token;
    const { baseURL, config } = generateConfig({ token });

    try {
      const response = await axios.post(
        `${baseURL}/api/clinics/${clinicId}/resources`,
        resourceData,
        config
      );
      return response.data;
    } catch (error) {
      return handleApiError(error, rejectWithValue, dispatch);
    }
  }
);

export const updateResource = createAsyncThunk(
  "resources/updateResource",
  async (
    { clinicId, resourceId, resourceData },
    { rejectWithValue, getState, dispatch }
  ) => {
    const state = getState();
    const token = state.auth.token;
    const { baseURL, config } = generateConfig({ token });

    try {
      const response = await axios.patch(
        `${baseURL}/api/clinics/${clinicId}/resources/${resourceId}`,
        resourceData,
        config
      );
      return response.data;
    } catch (error) {
      return handleApiError(error, rejectWithValue, dispatch);
    }
  }
);

export const deleteResource = createAsyncThunk(
  "resources/deleteResource",
  async ({ clinicId, resourceId }, { rejectWithValue, getState, dispatch }) => {
    const state = getState();
    const token = state.auth.token;
    const { baseURL, config } = generateConfig({ token });

    try {
      const response = await axios.delete(
        `${baseURL}/api/clinics/${clinicId}/resources/${resourceId}`,
        config
      );
      return response.data;
    } catch (error) {
      return handleApiError(error, rejectWithValue, dispatch);
    }
  }
);
